// extracted by mini-css-extract-plugin
export default {"AccordionTextItem":"AccordionTextItem_AccordionTextItem__EKC06"};